module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-4"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-4-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-with-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }, [_c('div', {
    staticClass: "element-number"
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Lucy In The Sky With Diamonds")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("December 2000")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-4-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _vm._v(" tentatively stuck my head around the light oak door frame of Room 8 at Mariners Rest Residential. The fake brass number on the door bore evidence of a smeared fingerprint, which along with the odour of disinfectant and school dinners, struck hard at my heart giving it a slight, painful jolt.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dad was framed in profile sitting in front of the large floor to ceiling window in a mustard yellow, high-backed, faux leather chair. He had been transferred to here from Birchwood, a type of halfway-house, until he was capable of some sort of independent living. I stood silent for a while, watching him as he gazed out onto the tree filled garden, barren of leaves. I briefly wonder what is going through his mind whilst knowing exactly what is going through mine. He has been here for so long. Each time I had lost courage at the gates, my promised visits had gone unfulfilled, another year passed, another year living with guilt and anger. Maybe it was now time to put things to rest.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I had two choices.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Stay and try to salvage some relationship with him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Turn and run.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The sudden twitch in my calves gave me the momentum to move. He hadn’t seen me. I could just quickly leave, go back to my life, forget about him just as he had forgotten about me, Michael and Connie all those years ago. I turned around, consoling myself that he would never know I had been here. Justifying what I was about to do.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I can smell your perfume, Mavis; I know you’re there.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As his rough voice broke the silence, I stood frozen to the spot. His fingers gently drummed on the wooden tip of the chair arm, yet he still didn’t move.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I wouldn’t blame you for leaving.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He sounded so sad, defeated almost. He carried on staring out of the window. I bristled, my breath coming in short gasps. “That’s not fair, that is so wrong, you’re trying to make me feel bad. I’ve felt bad all my life, YOU made me feel as though it was all my fault you ran away.” A huge sob caught in my throat as hot tears spilled over onto my cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Angrily I brushed them away with the heel of my hand. “It was you, you and nobody else that did this to us Dad, so why do I feel I’m to blame, you tell me that hey?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It was out. I couldn’t hold it in any longer. All the anger, hurt and betrayal. He slowly turned to look at me. His rheumy green eyes framed by furrowed brow. Those same green eyes I had always imagined him to have.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Sorry just doesn’t seem enough does it love?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I shook my head, not so much in agreement, more from incredulity. “No Dad, no… not nearly enough!”")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Placing the last pink rose into the holder, I deftly rearranged the gypsophila until it clouded out around the arrangement on Mum’s headstone. I sat back on my heels, happy that she would wholeheartedly approve of my flourishing floristry skills.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I went to see him Mum, I know I said I wouldn’t, I was really torn but the lads persuaded me to.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I did what I always did on my weekly visits to the churchyard, I waited for what would have been Mum’s response if she had been alive, just as I always had on our mum and daughter chats. She never replied anymore, no matter how much I wanted her to, but I would imagine in my head that she had. Her ghostly voice being as real as if she were standing next to me.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("‘I was prostate with grief Mavis, it might be an enema for you but it’s cut and dried for me, I wouldn’t have anything to do with him.’")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I smiled to myself, I was getting pretty good at thinking up malapropisms for her, they sort of kept her alive.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I know, but he’s old and he’s sick Mum, I can’t abandon him, can I? It’ll take time, but we’ll get there. His memory is so bad, he just keeps repeating the same thing over and over and getting things mixed up, it’s quite sad at times.” I paused for a while as a young couple, hand in hand, strolled through the leafy euonymus glade opposite, making towards the exit.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Talking to myself at home or in my patrol car was one thing, but doing it out in public, I’d probably end up in a room next to Dad.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As the old wooden arch gate banged shut and settled in the frame leaving me alone again, I carried on. “He thinks it’s 1969 and his latest earworm is the Beatles.” I pulled out a barely used tissue from my pocket and wiped away the water splashes from the gold leaf lettering, “He’s been singing "), _c('i', [_vm._v("The Girl with Colitis Goes By ")]), _vm._v("for two weeks now.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The gate creaked open as a white haired old lady wearing a pair of beige, down-at-heel sheepskin boots and clutching a large plastic bag, ambled up the path.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I watched her until she disappeared behind the church apse before carrying on. “It took the staff at the home forever to realise that the poor girl in question actually had kaleidoscope eyes and not some debilitating bowel condition!”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The wind fluttered gently through the canopy of branches on nearby yew trees, softly accompanying the imaginary sound of my mum’s laughter.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3544bcb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-004.vue
// module id = 84
// module chunks = 0